import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import {
  get,
  post
} from '@/utils/axios';
import Print from "vue-print-nb";
Vue.use(Print);
Vue.use(ElementUI);
Vue.prototype.$http = axios;
Vue.prototype.$GET = get;
Vue.prototype.$POST = post;
Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')